import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import MapsComponent from '../dashboard/MapVisualizationComponent';

function MapVisualizationView() {
  return (
    <MainLayout>
      <MapsComponent />
    </MainLayout>
  );
}

export default MapVisualizationView;
